const getPartnerId = (rootState) =>
  rootState.ws.integration.settings.userData &&
  rootState.ws.integration.settings.userData.partner_id;

export default getPartnerId;
